import axiosInstance from "./axiosInstance";

export interface VehicleSearchItem {
  publicId: string;
  registrationNumber: string;
  chassisNumber: string;
  registrationValidityDate: string;
  registrationDate: string;
  engineNumber: string;
  fuelType: string;
  vehicleTypeName: string;
  vehicleTypePublicId: string;
  makersName: string;
  modelName: string;
  color: string;
  bodyType: string;
  manufacturingMonthYear: string;
  yearOfPurchase: number;
  seatingCapacity: number;
  horsePower: number;
  cubicCapacity: number;
  registrationAuthorityName: string;
  belongsTo: string;
  notes: string;
  isActive: boolean;
}

export interface VehicleSearchParams {
  RegistrationNumber?: string;
  ChassisNumber?: string;
  MakersName?: string;
  ModelName?: string;
  FuelType?: string;
  VehicleTypePublicId?: string;
  BelongsTo?: string;
  IsActive?: boolean;
  PageNumber?: number;
  PageSize?: number;
}

export interface VehicleSearchResponse {
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  success: boolean;
  message: string;
  data: VehicleSearchItem[];
  errors: string[];
}
export interface VehicleApiResponse {
  success: boolean;
  message: string;
  data: VehicleSearchItem;
  errors: string[];
}

export interface CreateVehiclePayload {
  registrationNumber: string;
  chassisNumber: string;
  registrationValidityDate: string;
  registrationDate: string;
  vehicleTypePublicId: string;
  makersName: string;
  modelName: string;
  color: string;
  fuelType: string;
  manufacturingMonthYear: string;
  yearOfPurchase: number;
  seatingCapacity: number;
  belongsTo: string;
  notes: string;
  isActive: boolean;
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const searchVehicles = async (
  params: VehicleSearchParams = {}
): Promise<VehicleSearchResponse> => {
  const res = await axiosInstance.get("/Vehicles/search", {
    params,
    headers: getAuthHeader(),
  });

  return res.data;
};

export const getVehicleById = async (
  publicId: string,
): Promise<VehicleApiResponse> => {
  const res = await axiosInstance.get(`/Vehicles/${publicId}`, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const createVehicle = async (
  payload: CreateVehiclePayload,
): Promise<VehicleApiResponse> => {
  const res = await axiosInstance.post("/Vehicles", payload, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const updateVehicle = async (
  publicId: string,
  payload: CreateVehiclePayload,
): Promise<VehicleApiResponse> => {
  const res = await axiosInstance.put(
    `/Vehicles/${publicId}`,
    payload,
    {
      headers: getAuthHeader(),
    },
  );

  return res.data;
};